// removed by extract-text-webpack-plugin
module.exports = {"gray":"_3mAxdfRYb3afTyoiKgAyZH","item":"xcAT3xFqCvkf1487LN5-Q","radio":"_21DVKmHl5SNvBRdbyqXAqo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SingleInvoiceInfo/SingleInvoiceInfo.scss
 ** module id = 1040
 ** module chunks = 0
 **/